import { ToggleButton, type ToggleButtonProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'SearchToggleButton' })({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

interface SearchToggleButtonProps extends Omit<ToggleButtonProps, 'value'> {
  readonly value?: any;
}

export const SearchToggleButton: React.FC<SearchToggleButtonProps> = ({
  color = 'info',
  ...restProps
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <ToggleButton
        color={color}
        value
        {...restProps}
      />
    </div>
  );
};
